// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type CustomSmtpQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type CustomSmtpQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id'>
      & { custom_smtp?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CustomSMTP' }
        & Pick<PrivateSchemaTypes.CustomSmtp, 'enabled'>
        & { configuration: (
          { __typename?: 'CustomSMTPConfiguration' }
          & Pick<PrivateSchemaTypes.CustomSmtpConfiguration, 'host' | 'port' | 'user' | 'pass' | 'validated_at'>
        ), emailIdentity?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'EmailIdentityAsAdminModel' }
          & Pick<PrivateSchemaTypes.EmailIdentityAsAdminModel, 'id' | 'verified_at' | 'name' | 'email'>
        )> }
      )> }
    )> }
  )> }
);

export type PatchCustomSmtpMutationVariables = PrivateSchemaTypes.Exact<{
  input: PrivateSchemaTypes.CustomSmtpInput;
}>;


export type PatchCustomSmtpMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminMutations, 'id'>
      & { setCustomSMTP?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CustomSMTP' }
        & Pick<PrivateSchemaTypes.CustomSmtp, 'enabled'>
        & { configuration: (
          { __typename?: 'CustomSMTPConfiguration' }
          & Pick<PrivateSchemaTypes.CustomSmtpConfiguration, 'host' | 'port' | 'user' | 'pass' | 'validated_at'>
        ) }
      ) | (
        { __typename?: 'CustomSMTPError' }
        & Pick<PrivateSchemaTypes.CustomSmtpError, 'error'>
      )> }
    )> }
  )> }
);

export type SetEnabledCustomSmtpMutationVariables = PrivateSchemaTypes.Exact<{
  value: PrivateSchemaTypes.Scalars['Boolean'];
}>;


export type SetEnabledCustomSmtpMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminMutations, 'id'>
      & { custom_smtp?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CustomSMTP' }
        & { setEnabled?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CustomSMTP' }
          & Pick<PrivateSchemaTypes.CustomSmtp, 'enabled'>
        )> }
      )> }
    )> }
  )> }
);

export type VerifyCustomSenderEmailMutationVariables = PrivateSchemaTypes.Exact<{
  token: PrivateSchemaTypes.Scalars['String'];
}>;


export type VerifyCustomSenderEmailMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminMutations, 'id'>
      & { verifyCustomSenderEmail?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'EmailIdentityModel' }
        & Pick<PrivateSchemaTypes.EmailIdentityModel, 'id' | 'verified_at'>
      )> }
    )> }
  )> }
);


export const CustomSmtpDocument = gql`
    query customSMTP {
  admin {
    organisation {
      id
      custom_smtp {
        enabled
        configuration {
          host
          port
          user
          pass
          validated_at
        }
        emailIdentity {
          id
          verified_at
          name
          email
        }
      }
    }
  }
}
    `;

/**
 * __useCustomSmtpQuery__
 *
 * To run a query within a React component, call `useCustomSmtpQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomSmtpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomSmtpQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomSmtpQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CustomSmtpQuery, CustomSmtpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomSmtpQuery, CustomSmtpQueryVariables>(CustomSmtpDocument, options);
      }
export function useCustomSmtpLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomSmtpQuery, CustomSmtpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomSmtpQuery, CustomSmtpQueryVariables>(CustomSmtpDocument, options);
        }
export type CustomSmtpQueryHookResult = ReturnType<typeof useCustomSmtpQuery>;
export type CustomSmtpLazyQueryHookResult = ReturnType<typeof useCustomSmtpLazyQuery>;
export type CustomSmtpQueryResult = Apollo.QueryResult<CustomSmtpQuery, CustomSmtpQueryVariables>;
export const PatchCustomSmtpDocument = gql`
    mutation patchCustomSMTP($input: CustomSMTPInput!) {
  admin {
    organisation {
      id
      setCustomSMTP(input: $input) {
        ... on CustomSMTP {
          enabled
          configuration {
            host
            port
            user
            pass
            validated_at
          }
        }
        ... on CustomSMTPError {
          error
        }
      }
    }
  }
}
    `;
export type PatchCustomSmtpMutationFn = Apollo.MutationFunction<PatchCustomSmtpMutation, PatchCustomSmtpMutationVariables>;

/**
 * __usePatchCustomSmtpMutation__
 *
 * To run a mutation, you first call `usePatchCustomSmtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchCustomSmtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchCustomSmtpMutation, { data, loading, error }] = usePatchCustomSmtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchCustomSmtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PatchCustomSmtpMutation, PatchCustomSmtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PatchCustomSmtpMutation, PatchCustomSmtpMutationVariables>(PatchCustomSmtpDocument, options);
      }
export type PatchCustomSmtpMutationHookResult = ReturnType<typeof usePatchCustomSmtpMutation>;
export type PatchCustomSmtpMutationResult = Apollo.MutationResult<PatchCustomSmtpMutation>;
export type PatchCustomSmtpMutationOptions = Apollo.BaseMutationOptions<PatchCustomSmtpMutation, PatchCustomSmtpMutationVariables>;
export const SetEnabledCustomSmtpDocument = gql`
    mutation setEnabledCustomSMTP($value: Boolean!) {
  admin {
    organisation {
      id
      custom_smtp {
        setEnabled(value: $value) {
          enabled
        }
      }
    }
  }
}
    `;
export type SetEnabledCustomSmtpMutationFn = Apollo.MutationFunction<SetEnabledCustomSmtpMutation, SetEnabledCustomSmtpMutationVariables>;

/**
 * __useSetEnabledCustomSmtpMutation__
 *
 * To run a mutation, you first call `useSetEnabledCustomSmtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEnabledCustomSmtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEnabledCustomSmtpMutation, { data, loading, error }] = useSetEnabledCustomSmtpMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetEnabledCustomSmtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEnabledCustomSmtpMutation, SetEnabledCustomSmtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetEnabledCustomSmtpMutation, SetEnabledCustomSmtpMutationVariables>(SetEnabledCustomSmtpDocument, options);
      }
export type SetEnabledCustomSmtpMutationHookResult = ReturnType<typeof useSetEnabledCustomSmtpMutation>;
export type SetEnabledCustomSmtpMutationResult = Apollo.MutationResult<SetEnabledCustomSmtpMutation>;
export type SetEnabledCustomSmtpMutationOptions = Apollo.BaseMutationOptions<SetEnabledCustomSmtpMutation, SetEnabledCustomSmtpMutationVariables>;
export const VerifyCustomSenderEmailDocument = gql`
    mutation verifyCustomSenderEmail($token: String!) {
  admin {
    organisation {
      id
      verifyCustomSenderEmail(token: $token) {
        id
        verified_at
      }
    }
  }
}
    `;
export type VerifyCustomSenderEmailMutationFn = Apollo.MutationFunction<VerifyCustomSenderEmailMutation, VerifyCustomSenderEmailMutationVariables>;

/**
 * __useVerifyCustomSenderEmailMutation__
 *
 * To run a mutation, you first call `useVerifyCustomSenderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCustomSenderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCustomSenderEmailMutation, { data, loading, error }] = useVerifyCustomSenderEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyCustomSenderEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyCustomSenderEmailMutation, VerifyCustomSenderEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyCustomSenderEmailMutation, VerifyCustomSenderEmailMutationVariables>(VerifyCustomSenderEmailDocument, options);
      }
export type VerifyCustomSenderEmailMutationHookResult = ReturnType<typeof useVerifyCustomSenderEmailMutation>;
export type VerifyCustomSenderEmailMutationResult = Apollo.MutationResult<VerifyCustomSenderEmailMutation>;
export type VerifyCustomSenderEmailMutationOptions = Apollo.BaseMutationOptions<VerifyCustomSenderEmailMutation, VerifyCustomSenderEmailMutationVariables>;